import type { KlineSeries } from '../data/klines';
export function candleCsv(series: KlineSeries): string {
  const rows=['time_utc,open,high,low,close,volume'];
  for(let i=0;i<series.length;i++){
    const b=series.bar(i);
    rows.push([new Date(b.time).toISOString(),b.open,b.high,b.low,b.close,b.volume].join(','));
  }
  return rows.join('\r\n');
}
export function downloadCsv(content:string, name:string) {
  const url=URL.createObjectURL(new Blob([content],{type:'text/csv;charset=utf-8'}));
  const link=document.createElement('a'); link.href=url; link.download=name; link.click();
  setTimeout(()=>URL.revokeObjectURL(url),1000);
}
